import { Button, Col, Container, Row } from "react-bootstrap";
import './header.css';


function Header(){
    return(
    <header id="section1">
        <Container>
            <Row>
                <Col sm={5}>
                    <h2>Good food choices are good investments.</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit . Etiam et purus a odio finibus bibendum amet leo.</p>
                    <Button id="buy-now">Order Now </Button>
                    <Button id="learn-more">Learn More</Button>
                </Col>
                <Col></Col>
            </Row>
        </Container>
    </header>
    )
}
export default Header;